import React from 'react';
import { useTranslation } from 'react-i18next';

import { AssetManager } from '../../../../../viewer/asset-manager';
import { AssetSaveState, ElementObj } from '../../../../../viewer/elements/element-obj';
import { Point2d } from '../../../../../viewer/utilities/math-helpers';
import { InputDialog } from '../../../input-dialog/input-dialog';
import { CategoryContext } from '../../state/category-state';

type Props = {
  asset: ElementObj;
  pos?: Point2d;
  onClose: () => void;
};

const EditAssetNameDialog = (props: Props) => {
  const { t } = useTranslation();
  const { refreshAssets } = React.useContext(CategoryContext);

  return (
    <InputDialog
      initialValue={props.asset.name}
      position={props.pos}
      title={t('common.editAssetDialog.title', { ns: 'skyviewAssetMenu' })}
      onCancel={async () => {
        props.onClose();
        return Promise.resolve();
      }}
      onConfirm={async (newValue) => {
        const prevName = props.asset.name;
        try {
          props.asset.name = newValue;
          await AssetManager.instance.save(props.asset);
          refreshAssets();
          props.onClose();
        } catch (err) {
          props.asset.saveState = AssetSaveState.Idle;
          props.asset.name = prevName;
          throw err;
        }
      }}
    />
  );
};

export { EditAssetNameDialog, Props as EditAssetNameDialogProps };
